import React, { useState } from 'react'
import axios from 'axios'
import Input from '../components/customs/Input'
export default function Login({ setLoggedin }) {
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const login = async () => {
        try {
            const response = await axios.post("/api/admin-login/login", { email, password });
            const { token } = response.data;
            if (token) {
                setLoggedin(true);
                localStorage.setItem("logged_in_token", JSON.stringify({ logged_in: true, token }));
            }
        } catch (error) {
            alert("Wrong username or password");
        }
    }
    return (
        <section className="d-flex align-items-center justify-content-center gradient-form">
            <div className="card">
                <div className="row">
                    <div className="col-lg-6 d-flex align-items-center gradient-custom-2">
                        <div className="text-white">
                            <h4 className="mb-4">Feasti Dash Inc.</h4>
                            <p className="small mb-0">Some texts to be written</p>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <form className='card-body'>
                            <Input
                                label="Username"
                                type="email"
                                name="email"
                                required={true}
                                handler={(e) => setEmail(e.target.value)}
                            />
                            <Input
                                label="Password"
                                type="password"
                                name="password"
                                required={true}
                                handler={(e) => setPassword(e.target.value)}
                            />
                            <button
                                className="btn btn-primary btn-block gradient-custom-2"
                                type="button"
                                onClick={login}
                            >Log in</button>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    )
}
